import React, { useEffect } from "react";
import Editor from "../../../form/Editor";
import Input from "../../../form/Input";
import Select from "../../../form/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import {
  bannerAddEdit,
  bannerDetails,
} from "../../../../services/bannersService";
import FileUploadSingle from "../../../form/FileUploadSingle";
import Textarea from "../../../form/Textarea";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getDetailsObject } from "../../../../util/Flag";
import { useSearchParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";
import ImageOrVideoUploadSingle from "../../../form/ImageOrVideoUpload";
import { pageAddEdit, pageDetails } from "../../../../services/pageService";
import FileUploadMultiple from "../../../form/FileUploadMultiple";
import HomeHiwForm from "./HomeHiwForm";

const validation = {
  title: { required: true, message: "title is required" },
  description: { required: true, message: "description is required" },
};

const ManageFooterPagesSection = () => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    initialState: {
      button: [{ label: "", link: "" }],
      seoTitle: "",
      seoKeyword: "",
      seoDescription: "",
      seoAuthor: "",
    },
    validationRules: validation,
  });

  const [searchParams] = useSearchParams();
  const idFromUrl = searchParams.get("pageId");
  const navigate = useNavigate();

  const { data, updateData, isFetching, refetch } = useFetch({
    dependencies: ["pageDtls"],
    fetchFunction: async () => {
      const res = await pageDetails({
        id: idFromUrl,
      });
      return res?.data;
    },
  });

  useEffect(() => {
    if (data?._id) {
      const bannerDetailsMap = {
        home: ["testimonial", "how-it-works", "pricing", "faq"],
      };
      const detailsToSet = bannerDetailsMap[data?.bannerType] || [];
      // Extract dynamic fields from details
      const extractedDetails = detailsToSet.reduce((acc, key) => {
        acc[`${key}Title`] = data?.details?.[key]?.title || "";
        acc[`${key}Desc`] = data?.details?.[key]?.description || "";
        return acc;
      }, {});

      setFieldsValue({
        ...data,
        image: data?.image || [],
        button:
          data?.button?.map((item) => ({
            label: item?.buttonText,
            link: item?.buttonLink,
          })) || [],
        seoTitle: data?.seo?.seoTitle,
        seoKeyword: data?.seo?.seoKeyword,
        seoDescription: data?.seo?.seoDescription,
        seoAuthor: data?.seo?.seoAuthor,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        ...val,
        secondSubSection: val?.secondSubSection || [],
        secondSubSectionHead: val?.secondSubSectionHead || {},

        seo: {
          seoTitle: val?.seoTitle,
          seoKeyword: val?.seoKeyword,
          seoDescription: val?.seoDescription,
          seoAuthor: val?.seoAuthor,
        },
        button: val?.button?.map((item) => ({
          buttonText: item?.label,
          buttonLink: item?.link,
        })),
        image:
          [
            ...val.image?.filter((f) => !(f?.file instanceof File)), // existing files (paths/URLs)
            ...val.image
              ?.filter((f) => f?.file instanceof File)
              .map((f) => f.file), // new uploads
          ] || [],
        ...(data?._id && { id: data?._id }),
        // details: getDetailsObject(val.bannerType, val),
      };

      return await pageAddEdit(payload);
    },
    onSuccess: (res) => {
      if (res?.status === 200 || res?.status === 201) {
        toast.success(res?.message);
        navigate("/admin/footer-pages");
      } else {
        toast.warning(res?.message || res?.error);
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  function buttonGenerateHandler() {
    setFieldsValue({
      button: [...values?.button, { label: "", link: "" }],
    });
  }

  const getBannerComponent = (bannerType, props) => {
    const bannerComponents = {
      // projects: <ProjectsBannerForm {...props} />,
      // contact: <ContactBannerForm {...props} />,
    };

    return bannerComponents[bannerType] || null;
  };

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="space-y-8">
        <div className="font-bold text-center text-lg xl:text-3xl text-chestnut-rose">
          Footer Pages Management
        </div>
        <div className="grid grid-cols-12 gap-x-4 gap-y-4">
          <div className="relative col-span-12">
            {/* <Input
              label="Banner Title"
              inputPlaceholder={"Enter Banner Title"}
              inputName="title"
              value={values?.title}
              onChange={handleChange}
              {...formValidate(errors, "title")}
            /> */}
            <Editor
              label="Banner Title"
              value={values?.title}
              onChange={(val) =>
                handleChange({ target: { name: "title", value: val } })
              }
              placeholder="Enter Banner Title"
              {...formValidate(errors, "title")}
            />
          </div>
          {/* <div className="relative col-span-6">
            <FileUploadMultiple
              label={"Upload image"}
              onChange={(files) =>
                handleChange({ target: { name: "image", value: files } })
              }
              onRemove={(files) =>
                handleChange({ target: { name: "image", value: files } })
              }
              values={values?.image}
              sectionId={values?._id}
            />
          </div> */}

          <div className="relative col-span-12">
            <Editor
              label="Description"
              value={values?.description}
              onChange={(val) =>
                handleChange({ target: { name: "description", value: val } })
              }
              {...formValidate(errors, "description")}
            />
          </div>
          <div className="relative col-span-12 space-y-4">
            <div className="space-y-4">
              {values?.button?.map((item, i) => (
                <div key={i?.toString()} className="flex items-end space-x-4">
                  <div className="flex-shrink flex-grow w-1/2">
                    <Input
                      label={"Button label " + (i + 1)}
                      value={item?.label}
                      inputPlaceholder={"Enter button label"}
                      onChange={(e) => {
                        setFieldsValue({
                          button: values?.button?.map((item, index) =>
                            i === index
                              ? { ...item, label: e.target.value }
                              : item
                          ),
                        });
                      }}
                    />
                  </div>
                  <div className="flex-shrink flex-grow w-1/2">
                    <Input
                      label={"Button link " + (i + 1)}
                      value={item?.link}
                      inputPlaceholder={"Enter button link"}
                      onChange={(e) => {
                        setFieldsValue({
                          button: values?.button?.map((item, index) =>
                            i === index
                              ? { ...item, link: e.target.value }
                              : item
                          ),
                        });
                      }}
                    />
                  </div>
                  <div className="flex-shrink-0 !ml-0">
                    <Button
                      buttonIcon={"fa-regular fa-trash-can"}
                      buttonClasses={"!bg-transparent !text-chestnut-rose"}
                      buttonIconPosition={"left"}
                      buttonFunction={() => {
                        setFieldsValue({
                          button: values?.button?.filter(
                            (item, index) => i !== index
                          ),
                        });
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
            {/* <div className="flex items-center">
              <Button
                buttonClasses={
                  "!text-chestnut-rose !h-6 !p-0 !rounded-none !bg-transparent"
                }
                buttonLabel={"Add Action"}
                buttonLabelClasses={"!text-sm"}
                buttonFunction={() => buttonGenerateHandler()}
              />
            </div> */}
          </div>
          {/* <div className="relative col-span-12">
            <Editor
              label="Short Description"
              value={values?.contentDescription}
              onChange={(val) =>
                handleChange({
                  target: { name: "shortDescription", value: val },
                })
              }
              {...formValidate(errors, "shortDescription")}
            />
          </div> */}
          {values?.pageFor?.toLowerCase() === "home" && (
            <HomeHiwForm
              values={values}
              handleChange={handleChange}
              setFieldsValue={setFieldsValue}
            />
          )}

          {/* <div className="relative col-span-12">
            {getBannerComponent(values.bannerType, {
              values,
              handleChange,
              errors,
              formValidate,
            })}
          </div> */}
          <div className="relative col-span-12">
            <h4 className="font-semibold text-lg mb-2">SEO Section</h4>
            <div className="grid grid-cols-12 gap-4">
              <div className="relative col-span-6">
                <Input
                  label="SEO Title"
                  inputPlaceholder={"Enter SEO Title"}
                  inputName="seoTitle"
                  value={values?.seoTitle}
                  onChange={handleChange}
                  {...formValidate(errors, "seoTitle")}
                />
              </div>
              <div className="relative col-span-6">
                <Textarea
                  label="SEO Description"
                  inputPlaceholder={"Enter SEO Description"}
                  inputName="seoDescription"
                  inputValue={values?.seoDescription}
                  onChange={handleChange}
                  {...formValidate(errors, "seoDescription")}
                />
              </div>
              <div className="relative col-span-6">
                <Input
                  label="SEO Keyword"
                  inputPlaceholder={"Enter SEO Keyword"}
                  inputName="seoKeyword"
                  value={values?.seoKeyword}
                  onChange={handleChange}
                  {...formValidate(errors, "seoKeyword")}
                />
              </div>
              <div className="relative col-span-6">
                <Textarea
                  label="SEO Author Content"
                  inputPlaceholder={"Enter SEO Description"}
                  inputName="seoAuthor"
                  inputValue={values?.seoAuthor}
                  onChange={handleChange}
                  {...formValidate(errors, "seoAuthor")}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="relative col-span-4 mt-5">
          <div className="flex items-center justify-center gap-4">
            <Button
              buttonLabel={"Back"}
              buttonClasses={
                "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              }
              buttonLabelClasses={"mx-auto"}
              buttonHasLink
              buttonLink={"/admin/footer-pages"}
            />
            <Button
              buttonType="submit"
              buttonLabel={data?._id ? "Update Page" : "Save Page"}
              buttonClasses={
                "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              }
              buttonLabelClasses={"mx-auto"}
              {...(isLoading && {
                loading: true,
                buttonIconPosition: "left",
                isDisable: true,
              })}
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default ManageFooterPagesSection;
